var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyinbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_559_34414)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 41H28.3033C28.9349 41 29.5122 41.357 29.7944 41.922L30.5382 43.4114C30.8204 43.9763 31.3977 44.3333 32.0292 44.3333H39.9691C40.6004 44.3333 41.1775 43.9767 41.4598 43.412L42.2052 41.9213C42.4875 41.3567 43.0646 41 43.6959 41H51",
    stroke: "url(#paint0_linear_559_34414)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 21C48.7614 21 51 23.2386 51 26V46C51 48.7614 48.7614 51 46 51H26C23.2386 51 21 48.7614 21 46V26C21 23.2386 23.2386 21 26 21H46Z",
    stroke: "url(#paint1_linear_559_34414)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9993 36.7409V28.4075",
    stroke: "url(#paint2_linear_559_34414)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.666 33.4083L35.9993 36.7417L39.3327 33.4083",
    stroke: "url(#paint3_linear_559_34414)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_559_34414",
    x: -9.53674e-7,
    y: -9.53674e-7,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_559_34414"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_559_34414",
    result: "effect2_dropShadow_559_34414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_559_34414",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_559_34414",
    x1: 36,
    y1: 41,
    x2: 36,
    y2: 44.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_559_34414",
    x1: 36,
    y1: 21,
    x2: 36,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_559_34414",
    x1: 35.9993,
    y1: 28.4075,
    x2: 35.9993,
    y2: 36.7409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_559_34414",
    x1: 35.9993,
    y1: 33.4083,
    x2: 35.9993,
    y2: 36.7417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B349A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C37C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyinbox);
export default __webpack_public_path__ + "static/media/emptyinbox.0a51af7192c6ff3cf256e53a4ac0f352.svg";
export { ForwardRef as ReactComponent };